export default {
  key: '6LdlMe0ZAAAAAK0qr7v926sekKz6E9liL-uSxbLH',
};
